import { useCallback, useRef, useState } from "react";

const useLongPress = (
  onLongPress,
  onClick,
  { shouldPreventDefault = true, delay = 300, shouldLongPressBeContinuous = true, longPressDelay = 50 } = {}
) => {
  const [longPressTriggered, setLongPressTriggered] = useState(false);
  const [handlerHold, setHandlerHold] = useState(false);
  const timeout = useRef();
  const target = useRef();

  const start = useCallback(
    event => {
      event.preventDefault();
      if (shouldPreventDefault && event.target) {
        event.target.addEventListener("touchend", preventDefault, {
          passive: false
        });
        target.current = event.target;
      }
      timeout.current = setTimeout(() => {
        if (shouldLongPressBeContinuous) {
          setHandlerHold(setInterval(() => {
              onLongPress(event);
            }, longPressDelay)
          )
        } else {
          onLongPress(event);
        }
        setLongPressTriggered(true);

      }, delay);
    },
    [onLongPress, delay, shouldPreventDefault, shouldLongPressBeContinuous, longPressDelay]
  );

  const clear = useCallback(
    (event, shouldTriggerClick = true) => {
      event.preventDefault();
      timeout.current && clearTimeout(timeout.current);
      shouldTriggerClick && !longPressTriggered && onClick();
      setLongPressTriggered(false);
      if (shouldPreventDefault && target.current) {
        target.current.removeEventListener("touchend", preventDefault);
      }
      if (shouldLongPressBeContinuous) {
        clearInterval(handlerHold);
      }
    },
    [shouldPreventDefault, onClick, longPressTriggered, handlerHold, shouldLongPressBeContinuous]
  );

  return {
    onMouseDown: e => start(e),
    onTouchStart: e => start(e),
    onMouseUp: e => clear(e),
    onMouseLeave: e => clear(e, false),
    onTouchEnd: e => clear(e)
  };
};

const isTouchEvent = event => {
  return "touches" in event;
};

const preventDefault = event => {
  if (!isTouchEvent(event)) return;

  if (event.touches.length < 2 && event.preventDefault) {
    event.preventDefault();
  }
};

export default useLongPress;
